import { createRouter, createWebHistory } from 'vue-router'

const routes = [{
    path: '/',
    component: () => import('../views/main.vue'),
    children: [{
      path: 'welcome',
      component: () => import('../views/main/welcome.vue'),
    }, {
      path: 'about',
      component: () => import('../views/main/about.vue'),
    }, {
      path: 'safetyPromotion/',
      children: [{
        path: 'announcements-news',
        component: () => import('../views/main/safetyPromotion/announcements-news.vue'),
      }, {
        path: 'knowledgeBase',
        component: () => import('../views/main/safetyPromotion/knowledgeBase.vue'),
      }, {
        path: 'questions',
        component: () => import('../views/main/safetyPromotion/questions.vue'),
      }, {
        path: 'questionOptions',
        component: () => import('../views/main/safetyPromotion/questionOptions.vue'),
      }, {
        path: 'answers',
        component: () => import('../views/main/safetyPromotion/answers.vue'),
      }]
    }, {
      path: 'user/',
      children: [{
        path: 'user',
        component: () => import('../views/main/user/users.vue')
      }]
    }]
  }, {
    path: '',
    redirect: '/welcome'
  }];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
